import { render } from "./ContabilitaAzienda.vue?vue&type=template&id=2cdbaf7a&ts=true"
import script from "./ContabilitaAzienda.vue?vue&type=script&lang=ts"
export * from "./ContabilitaAzienda.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__